import { render, staticRenderFns } from "./TabelaProdutos.vue?vue&type=template&id=4cb3f00c&scoped=true"
import script from "./TabelaProdutos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaProdutos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3f00c",
  null
  
)

export default component.exports